var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'tablet-mode': _vm.isTabletMode },attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_c('RouterView')],1),_vm._v(" "),(_vm.showViewportDebug)?_c('ViewportDebugPanel'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }